import { IEventRequest } from '../context/model';
import { notificationApi } from './BaseApiService';


export function pushEventMessage(jwt: string, event: IEventRequest) {
  return notificationApi(jwt).post(`/events`, event);
}

